import { params } from "../../vars/params";
import { config } from "../../../config";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger);

export const scrollIn = (): void => {
  const triggers = document.querySelectorAll("[data-anim-trigger]");
  const anims = document.querySelectorAll("[data-anim]");
  const titles = document.querySelectorAll("[data-anim-title]");
  const zooms = document.querySelectorAll("[data-zoom]");
  const fades = document.querySelectorAll("[data-fade]");
  const typeIns = document.querySelectorAll("[data-type-in]");
  const cards = document.querySelectorAll("[data-card]");
  const ctas = document.querySelectorAll(".c-cta");
  const isSp = window.innerWidth < config.breakPoint;
  const endStart = isSp ? "top 120px" : "bottom 40%";
  const endEnd = isSp ? "top 60px" : "bottom 20%";
  triggers.forEach((trigger) => {
    const staggers = trigger.querySelectorAll("[data-stagger]");
    gsap.to(staggers, {
      opacity: 1,
      y: 0,
      duration: 0.4,
      stagger: 0.15,
      scrollTrigger: {
        trigger: trigger,
        start: `top ${params.isSp ? config.triggerPos.sp : config.triggerPos.pc}`,
        toggleClass: { targets: staggers, className: "--scrolled" },
        toggleActions: "play none none reverse",
      },
    });
  });
  anims.forEach((anim) => {
    gsap.to(anim, {
      opacity: 1,
      y: 0,
      duration: 0.4,
      stagger: 0.1,
      scrollTrigger: {
        trigger: anim,
        start: `top ${params.isSp ? config.triggerPos.sp : config.triggerPos.pc}`,
        toggleActions: "play none none reverse",
      },
    });
  });
  // titles.forEach((title) => {
  //   const en = title.querySelector(".c-ttl-sec__inner") as HTMLElement;
  //   const ja = title.querySelector(".c-ttl-sec__ja") as HTMLElement;
  //   const tl = gsap.timeline({
  //     scrollTrigger: {
  //       trigger: title,
  //       start: `top ${params.isSp ? config.triggerPos.sp : config.triggerPos.pc}`,
  //       toggleActions: "play none none reverse",
  //     },
  //   });
  //   tl.to(en, {
  //     opacity: 1,
  //     duration: 1.5,
  //   });
  //   tl.to(
  //     ja,
  //     {
  //       opacity: 1,
  //       duration: 0.5,
  //     },
  //     "<0.4"
  //   );
  // });
  zooms.forEach((zoom) => {
    const zoomElm = zoom as HTMLElement;
    const zoomType = zoomElm.dataset.zoom;
    if (zoomType === "in-out" || zoomType === "in") {
      const startTl = gsap.timeline({
        scrollTrigger: {
          trigger: zoomElm,
          start: "top 90%",
          end: "top 80%",
          scrub: true,
        },
      });
      startTl
        .to(zoomElm, {
          opacity: 1,
          duration: 1,
        })
        .fromTo(
          zoomElm,
          {
            scale: 0.5,
          },
          {
            scale: 1,
            ease: "power2.out",
            duration: 2,
          },
          0
        );
    }
    if (zoomType === "in-out" || zoomType === "out") {
      const endTl = gsap.timeline({
        scrollTrigger: {
          trigger: zoomElm,
          start: endStart,
          end: endEnd,
          scrub: true,
        },
      });
      endTl
        .to(
          zoomElm,
          {
            opacity: 0,
            duration: 1,
          },
          1
        )
        .fromTo(
          zoomElm,
          {
            scale: 1,
          },
          {
            scale: 0.5,
            ease: "power2.in",
            duration: 2,
          },
          0
        );
    }
  });
  fades.forEach((fade) => {
    const fadeElm = fade as HTMLElement;
    const fadeType = fadeElm.dataset.fade;
    const fadeTrigger = parseFloat(fadeElm.dataset.fadeTrigger || "0");
    const fadeDelay = parseFloat(fadeElm.dataset.delay || "0");
    const fadeDuration = parseFloat(fadeElm.dataset.duration || "0.5");
    if (fadeType === "in") {
      gsap.to(fadeElm, {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        duration: fadeDuration,
        delay: fadeDelay,
        scrollTrigger: {
          trigger: fadeElm,
          start: `top ${80 + fadeTrigger}%`,
          toggleActions: "play none none reverse",
        },
      });
    }
    if (fadeType === "in-up") {
      gsap.to(fadeElm, {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        duration: 0.5,
        scrollTrigger: {
          trigger: fadeElm,
          start: `top ${80 + fadeTrigger}%`,
          toggleActions: "play none none reverse",
        },
      });
    }
  });
  cards.forEach((card) => {
    const cardElm = card as HTMLElement;
    const cardType = cardElm.dataset.card;
    const cardStagger = parseFloat(cardElm.dataset.cardStagger || "0.2");
    const cardDuration = parseFloat(cardElm.dataset.cardDuration || "0.25");
    const cardItems = cardElm.querySelectorAll("[data-card-item]");
    cardItems.forEach((item, index) => {
      const startTl = gsap.timeline({
        ease: "none",
        scrollTrigger: {
          trigger: cardElm,
          start: "top 90%",
          end: "top 70%",
          toggleActions: "play none none reverse",
          // scrub: true,
        },
      });
      startTl.fromTo(
        item,
        {
          // scale: 0.7,
          // y: "10%",
          opacity: 0,
          filter: "blur(5px)",
        },
        {
          // scale: 1,
          // y: 0,
          opacity: 1,
          filter: "blur(0px)",
          ease: "power1.out",
          duration: cardDuration,
          delay: index * cardStagger,
        }
      );
    });
  });
  typeIns.forEach((typeIn) => {
    const typeInElm = typeIn as HTMLElement;
    const splitText = new SplitText(typeIn, { types: "chars", tag: "span", charsClass: "c-anim-char" });
    const delay = parseFloat(typeInElm.dataset.delay || "0");
    const duration = parseFloat(typeInElm.dataset.duration || "0.001");
    const tl = gsap.timeline({
      delay: delay,
      scrollTrigger: {
        trigger: typeInElm,
        start: "top 90%",
        // end: "top 80%",
        // scrub: true,
      },
    });
    tl.from(splitText.chars, {
      opacity: 0,
      duration: duration,
      stagger: 0.05,
    });
  });
  ctas.forEach((cta) => {
    const ctaElm = cta as HTMLElement;
    const origAngle = 122;
    const delta = 200;
    gsap.fromTo(
      ctaElm,
      {
        background: `linear-gradient(${origAngle - delta}deg, #1bb7a5 15%, #f000c6 90%)`,
        scale: 0.8,
      },
      {
        background: `linear-gradient(${origAngle + delta}deg, #1bb7a5 15%, #f000c6 90%)`,
        scale: 1,
        duration: 2,
        ease: "none",
        scrollTrigger: {
          trigger: ctaElm,
          start: "top 100%",
          end: "center 50%",
          scrub: true,
        },
      }
    );
  });
  const secTtls = document.querySelectorAll(".c-ttl-sec:not(.--anim-none)");
  if (secTtls.length > 0) {
    secTtls.forEach((secTtl) => {
      const secTtlElm = secTtl as HTMLElement;
      const sub = secTtlElm.querySelector(".c-ttl-sec__sub") as HTMLElement;
      const main = secTtlElm.querySelector(".c-ttl-sec__main") as HTMLElement;
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: secTtlElm,
          start: `top ${params.isSp ? config.triggerPos.sp : config.triggerPos.pc}`,
          toggleActions: "play none none reverse",
        },
      });
      tl.fromTo(
        sub,
        {
          opacity: 0,
          // y: 20,
          filter: "blur(10px)",
        },
        {
          opacity: 1,
          // y: 0,
          duration: 0.5,
          filter: "blur(0px)",
        }
      );
      tl.fromTo(
        main,
        {
          opacity: 0,
          // y: 20,
          filter: "blur(10px)",
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.5,
          filter: "blur(0px)",
        },
        0.2
      );
    });
  }
};
